const WelcomeBox = () => {
    return (
        <div className="container-form-4 transparent-content" style={{ margin: "0px" }}>
            <div className="row">
                <div className="col-12">
                    <span className="title-8">Bienvenido(a)</span>
                    <br/>
                    <span className="text-4">Completa los campos solicitados para comenzar a procesar los datos de tus portales B2B.</span>
                </div>
            </div>
        </div>
    );
};

export default WelcomeBox;
